import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityService {
  token_response: any = {};
  token: any;
  formSectionId: any;
  emailId: string;
  phoneId: string;
  addressId: string;

  constructor(
    private http: HttpClient) {
    this.token_response = JSON.parse(localStorage.getItem("volunteers_token_responseuat") || '{}');
    this.token = this.token_response.access_token;
  }

  Get_CRMCustomerAvailableTimeSlots(cRMCustomerId: any) {
    console.log(cRMCustomerId);
    return this.http.get(environment.GetCRMCustomerAvailableTimeSlots + '/' + this.token_response.CRMPersonId + '/' + this.token_response.tenantId + '/' + cRMCustomerId)
      .pipe(map((res: any) => {
        return res;
      }), catchError(error => {
        console.log(error);
        return throwError(error);
      }));
  }

  update_CRMCustomerAvailableTimeSlots(saveavailabilitytimesolts:any) {
    return this.http.post(environment.SaveOrUpdateCRMCustomerAvailableTimeSlots,saveavailabilitytimesolts, {
      responseType: 'text'
    }).pipe(map((res: any) => {
      return res;
    }), catchError(error => {
      console.log(error);
      return throwError(error);
    }));
  }
}
